import { render, staticRenderFns } from "./ImageSettingsMobile.vue?vue&type=template&id=639fbe3a&scoped=true&"
import script from "./ImageSettingsMobile.vue?vue&type=script&lang=ts&"
export * from "./ImageSettingsMobile.vue?vue&type=script&lang=ts&"
import style0 from "./ImageSettingsMobile.vue?vue&type=style&index=0&id=639fbe3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639fbe3a",
  null
  
)

export default component.exports